import { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import Editor from './editor';


export default function RHFEditor({ name, helperText, defaultValue, handleChange, isDefaultValue, ...other }: any) {
  const {
    control,
    watch,
    setValue,
    formState: { isSubmitSuccessful },
  } = useFormContext();

  const values = watch();

  useEffect(() => {
    if (values[name] === '<p><br></p>') {
      setValue(name, '', {
        shouldValidate: !isSubmitSuccessful,
      });
    }
  }, [isSubmitSuccessful, name, setValue, values]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => {
        return (
          <Editor
            id={name}
            value={field.value}
            onChange={(e: any) => {
              field.onChange(e);
              handleChange && handleChange(e)
            }}
            error={(!!error && !field.value)}
            helperText={
              ((!!error && !field.value) || helperText) && (
                <span className="text-sm text-rejectDark"> {error ? error.message : helperText}</span>
              )
            }
            isDefaultValue={isDefaultValue}
            {...other}
          />
        )
      }}
    />
  );
}
